module.exports = __webpack_public_path__ + "7b935dc09e087e5d0df00edc85f52da0.png";